var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress__container",class:{
    'mx-auto': _vm.isCenter,
    'no-transition': _vm.progress === 0,
    'fast-transition': _vm.progress === 100
  },style:({ 'max-width': _vm.maxWidthContainer ? _vm.maxWidthContainer + 'px' : 'unset' })},[_c('div',{staticClass:"progress__bar",style:({'width': _vm.progress ? _vm.progress + '%' : 0 })})])
}
var staticRenderFns = []

export { render, staticRenderFns }